import {SearchFormValuesType} from "../views/PropertyConfigurator";

export const getValuesWithCurrentSearchFieldState = (formValues: SearchFormValuesType, name?: string, value?: unknown): SearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
import {SearchFormValuesType} from "../views/PropertyConfigurator";

export const getValuesWithCurrentSearchFieldState = (formValues: SearchFormValuesType, name?: string, value?: unknown): SearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
